import CurrencyDevice from './currency-acceptor/CurrencyDevice';
import CurrencyAcceptor, { CurrencyAcceptorStub, CurrencyEventData, CurrencyEventType } from './currency-acceptor/CurrencyAcceptor';
import CheckReaderDevice from './check-reader/CheckReaderDevice';
import PertechCheckReader, { PertechCheckReaderStub } from './check-reader/PertechCheckReader';
import EMVDevice, { EMVDeviceStub, KioEMVResult, BillingInfo, KioEMVProductDescriptor, PayGoAccount } from './emv-device/EMVDevice';

declare global {
	interface Window {
		KioDevice: {
			GetStatusEx: (deviceName?: string) => string;
			GetStatus: (deviceName?: string) => number;
		};
		KioCheckReaderDevice: {
			GetStatusEx: (deviceName?: string) => string;
			SetPertechSetts: (enable: boolean, param2: boolean, param3: number, stampVoid: boolean, deviceName?: string) => void;
		};
		KioCurrencyAcceptor: {
			GetStatusEx: (deviceName?: string) => string;
			Enable: (deviceName?: string) => void;
			Reject: (deviceName?: string) => void;
			Stack: (deviceName?: string) => void;
			Disable: (deviceName?: string) => void;
		};
		KioEMVDevice: {
			GetStatusEx: (deviceName?: string) => string;
			GetState: (deviceName?: string) => number;
			Sale: (transactionJSON: string) => boolean;
			CancelTransaction: (deviceName?: string) => boolean;
			CreateCartGS: (billingInfo: BillingInfo, orderId: string, productDescriptors: KioEMVProductDescriptor[], devName: string) => boolean;
			PayGo_AccountLookup_Async: (
				deviceName: string | null,
				barCode: string | null,
				phoneNumber: string | null,
				emailAddress: string | null,
				registrationNumber: string | null,
				accountNumber: string | null
			) => PayGoAccount[];
		};
		KioUtils: {
			LogPageStats: (url: string, title: string) => void;
		};
		OnKioCurrencyDevice: (deviceName: string, eventType: CurrencyEventType, eventData: CurrencyEventData) => void;
		OnKioDeviceCmdResult: (deviceName: string, id: number, cmd: number, err: number, data: DeviceCmdResultData) => void;
		OnKioEMVTransactionCompleted: (emvResult: KioEMVResult) => void;
		OnKioEMVTransactionStateChanged: (deviceName: string, newState: number) => void;
		OnCreateCartGS: (res: string, isErr: boolean, errCode: number) => void;
		OnPayGoAccountLookup?: (res: string, isErr: boolean, errCode: number) => void;
	}
}

interface Devices {
	readonly currencyDevice: CurrencyDevice;
	readonly CurrencyDeviceStub: CurrencyDevice;
	readonly checkReader: CheckReaderDevice;
	readonly checkReaderStub: CheckReaderDevice;
	readonly emvDevice: EMVDevice | EMVDeviceStub;
}

export type DeviceCmdResultData = string | object;

export type KioDeviceListener = (deviceName: string, id: number, cmd: number, err: number, data: DeviceCmdResultData) => void;
export const kioDeviceListeners: KioDeviceListener[] = [];
window.OnKioDeviceCmdResult = (deviceName: string, id: number, cmd: number, err: number, data: DeviceCmdResultData) => {
	kioDeviceListeners.forEach((listener) => listener(deviceName, id, cmd, err, data));
};

const useEMVDevice = import.meta.env.VITE_USE_CARD_READER;
export const devices: Devices = {
	currencyDevice: new CurrencyAcceptor(),
	CurrencyDeviceStub: new CurrencyAcceptorStub(),
	checkReader: new PertechCheckReader(),
	checkReaderStub: new PertechCheckReaderStub(),
	emvDevice:
		useEMVDevice === 'always' || (useEMVDevice === 'with-fallback' && window.KioEMVDevice && window.KioDevice.GetStatus('EMV') === 0)
			? new EMVDevice()
			: new EMVDeviceStub(),
};
